import { ref, computed, onMounted } from 'vue';
import { useRoute } from '@/composables/common/router/useRouter';
import indumentariaService from '@/services/admin/bases/indumentarias';

export function useIndumentariaShow() {
    const route = useRoute();

    const indumentaria = ref(null);
    const loading = ref(true);

    const listaId = computed(() => route.params.lista_id);
    const indumentariaId = computed(() => route.params.indumentaria_id);

    async function fetchIndumentaria() {
        loading.value = true;
        try {
            const data = await indumentariaService.getIndumentaria({
                lista_id: listaId.value,
                indumentaria_id: indumentariaId.value,
            });
            indumentaria.value = data;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[useIndumentariaShow] Error fetching indumentaria:', error);
            }
            indumentaria.value = null;
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        fetchIndumentaria();
    });

    return {
        indumentaria,
        loading,
        listaId,
        indumentariaId,
    };
}
